export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/bags.025635f.svg";